import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { Destino } from "./model";

export interface Props {
    value: Destino;
    onVerEntregas: () => void;
    onEntregaIncompleta: () => void;
}

const VerEntregasButton = kea.defaultProps(kea.Button, { children: "Entregas", style: "primary", iconClass: fa("check") });
const IncompletaButton = kea.defaultProps(kea.Button, { children: "Incompleta", style: "danger", iconClass: fa("times") });

export class DestinoItem extends React.PureComponent<Props> {
    render() {
        const x = this.props.value;
        return (
            <kea.Panel title={x.DireccionCorta} iconClass={fa("user")}
                buttons={[
                    <IncompletaButton onClick={this.props.onEntregaIncompleta} />,
                    <VerEntregasButton onClick={this.props.onVerEntregas} />,
                ]}
                style={
                    (x.CantGuiasProcesadas == x.CantGuias) ?"success" :
                    x.CantGuiasProcesadas > 0 ? "warning" :
                    "default"}
                >
                <label>Cliente:</label>{x.NombreCliente}
                <br />

                <label>Guias procesadas/total:</label>{" "}{x.CantGuiasProcesadas}{"/"}{x.CantGuias}
                <br />

                <label>Paquetes:</label>{" "}{x.CantPaquetes}
                <br />

                <label>Sobres:</label>{" "}{x.CantSobres}
                <br />

                <label>Importe a pagar:</label>{" "}{kea.formatCurrency(x.ImportePagar)}
                <br />
                {
                    x.EstaIncompleto ?
                        <div className="alert alert-danger">
                            <label>Entrega incompleta</label>
                            <br />
                            <i>{x.MotivoIncompleto}</i>
                            <br />
                            {x.CantEntregasRealizadas} entregas pendientes
                        </div> :
                        (x.CantEntregasRealizadas > 0) ?
                            <div className="alert alert-info">
                                <label>{x.CantEntregasRealizadas} entregas realizadas</label>
                            </div> :
                            <div className="alert alert-warning">
                                <label>Sin entregas</label>
                            </div>
                }
            </kea.Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/item.tsx